import React from 'react';
import styled from 'styled-components';
import { Flex } from '../shared/Flex';
import ErrorIcon from '../../assets/error-icon.svg';

const Wrapper = styled(Flex)`
  position: relative;
  height: auto;
  min-height: 60px;
  width: 100%;
  justify-content: start;
  align-items: center;
  background-color: #FEF2F2; // Light Red
  border: 1px solid #EF4444;
  border-radius: 8px;
  padding: 15px 0;
  box-sizing: border-box;
`;

const Message = styled.div`
  padding: 0 10px;
  font-size: 14px;
  color: #231f20;
  text-align: left;
`;

const Solution = styled.div`
  padding: 4px 10px 0 10px;
  font-size: 13px;
  color: #4b5563;
  text-align: left;
  font-weight: 500;
`;

const Icon = styled.img`
  margin-left: 30px;
  flex-shrink: 0;
`;

const ErrorAlert = ({ message, solution }: { message?: string, solution?: string }) => {
  if (!message) {
    return null;
  }

  return (
    <Wrapper>
      <Icon src={ErrorIcon} />
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, paddingRight: '20px' }}>
        <Message>{message}</Message>
        {solution && <Solution>💡 Tip: {solution}</Solution>}
      </div>
    </Wrapper>
  );
};
export default ErrorAlert;
